import React, { useState, useRef, useEffect } from 'react';
import * as d3 from 'd3';
import '../styles/Charts.css';

// TODO take nameProps1 and nameProps2 as "name:" property
const ChartLine = ({dataProps1, dataProps2, nameProps1 = 'Dataset 1', nameProps2 = 'Dataset 2'}) => {
    // preset data if data props not given
    const [dataLine1, updateDataLine1] = useState([
        {date: new Date("2024-06-01"), value: 30},
        {date: new Date("2024-07-01"), value: 70},
        {date: new Date("2024-08-01"), value: 92}
    ]) 
    
    const [dataLine2, updateDataLine2] = useState([
        {date: new Date("2024-06-01"), value: 44},
        {date: new Date("2024-07-01"), value: 64},
        {date: new Date("2024-08-01"), value: 79}
    ])

    const data1 = dataProps1 || dataLine1;
    const data2 = dataProps2 || dataLine2;

    const svgRef = useRef();

    // Attributes of the chart
    const margin = { 
        top: 70,
        right: 30,
        bottom: 40,
        left: 80
    };
    const width = 400 - margin.left - margin.right;
    const height = 300 - margin.top - margin.bottom;
    
    useEffect(()=>{
        if (!data1 || data1.length === 0 || !data2 || data2.length === 0) return;

        const scaleX = d3.scaleTime()
            .range([0, width]);

        const scaleY = d3.scaleLinear()
            .range([height, 0]); 

        const svg = d3.select(svgRef.current)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        // define domains
        const combinedData = data1.concat(data2);
        scaleX.domain(d3.extent(combinedData, d => d.date));
        scaleY.domain([0, d3.max(combinedData, d => d.value)]); 

        // X axis
        svg.append('g')
            .attr('transform', `translate(0, ${height})`)
            .call(d3.axisBottom(scaleX)
                .ticks(d3.timeMonth.every(1))
                .tickFormat(d3.timeFormat("%b %Y"))
            );
            
        // Y axis
        svg.append('g')
        .call(d3.axisLeft(scaleY)
            .ticks(6)
            .tickFormat(d3.format(".1f")) // 1 decimal place
        );
    
        
        // line creator function
        const line1 = d3.line()
        .x(d => scaleX(d.date))
        .y(d => scaleY(d.value));

        const line2 = d3.line()
        .x(d => scaleX(d.date))
        .y(d => scaleY(d.value));

        // draw the line
        svg.append('path')
            .datum(data1)
            .attr('fill', 'none')
            .attr('stroke', '#606060')
            .attr('stroke-width', 2)
            .attr('d', line1);

        svg.append('path')
            .datum(data2)
            .attr('fill', 'none')
            .attr('stroke', '#61CE70')
            .attr('stroke-width', 2)
            .attr('d', line2);

        // Create legend labels above chart
        const labelsArea = d3.select('#labelsLine');
        labelsArea.selectAll('*').remove();

        const legendData = [
            { label: nameProps1, color: '#606060' },
            { label: nameProps2, color: '#61CE70' }
        ];

        const labelDivs = labelsArea.selectAll('div')
            .data(legendData)
            .enter()
            .append('div')
            .attr('class', 'label-container');

        labelDivs.append('div')
            .attr('class', 'color-circle')
            .style('background-color', d => d.color);

        labelDivs.append('span')
            .text(d => d.label)
            .attr('class', 'text-legend');

        return () => {
            svg.selectAll('path').remove(); // Cleanup on unmount or data change
        };

    }, [data1, data2])

    return (
        <div>
            <article id='labelsLine'>
                {/* data legend will be here */}
            </article>
            <svg
            ref={svgRef}
            width={width + margin.left + margin.right}
            height={height + margin.top + margin.bottom     }            
            >
            </svg>
        </div>
    )
}

export default ChartLine